import SessionConfig from '../../model/SessionConfig'
import { dataSource } from '../../service/domain/_service.config'
import { useAppConfig } from '../challenge/useAppConfig'
import { useChallenge } from '../challenge/useChallenge'
import { useChallengeId } from '../challenge/useChallengeId'

export const CONFIG_QUERY_KEY = ['sessionConfig']

/**
 * Legacy composite of challenge season settings + global app version config.
 * Prefer useChallengeContext() for new code.
 */
export function useConfig(challengeId?: string) {
  const activeChallengeId = useChallengeId()
  const resolvedChallengeId = challengeId || activeChallengeId
  const challengeQuery = useChallenge(resolvedChallengeId)
  const appConfigQuery = useAppConfig()

  const data =
    challengeQuery.data && appConfigQuery.data
      ? SessionConfig.from(challengeQuery.data, appConfigQuery.data)
      : undefined

  return {
    data,
    isLoading: challengeQuery.isLoading || appConfigQuery.isLoading,
    error: challengeQuery.error ?? appConfigQuery.error,
  }
}

/** Direct fetch for non-hook contexts (rare). */
export async function fetchSessionConfig(challengeId: string) {
  const [challenge, appConfig] = await Promise.all([
    dataSource.getChallenge(challengeId),
    dataSource.getAppConfig(),
  ])
  return SessionConfig.from(challenge, appConfig)
}
